import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import EditClassroomForm from './EditClassroomModalForm';
import GET_CLASSROOM_AND_ORGANIZATIONS from 'graph/composite/get-classroom-and-organizations-query';
import UPDATE_CLASSROOM_MUTATION from 'graph/classroom/update-classroom-mutation';
import useParseActionRouteParams from 'hooks/route-action/use-parse-action-route-params';
import PageContainer from 'components/@layout/PageContainer';

interface EditClassroomModalProps {
  onClose: (success?: boolean) => void;
}

const EditClassroomModal: React.FC<EditClassroomModalProps> = ({ onClose }) => {
  const { classroomId } = useParseActionRouteParams<{ classroomId: string }>();
  const { data, loading, error } = useQuery(GET_CLASSROOM_AND_ORGANIZATIONS, {
    variables: { where: { id: +classroomId } }
  });
  const [updateClassroom] = useMutation(UPDATE_CLASSROOM_MUTATION);

  return (
    <PageContainer loading={loading} error={error}>
      <EditClassroomForm
        classroom={data?.classroom || {}}
        organizations={data?.organizations || []}
        onClose={onClose}
        updateClassroom={updateClassroom}
      />
    </PageContainer>
  );
};

export default EditClassroomModal;
